<section app-home-hero></section>
<section app-home-fit-philosophy></section>
<section app-home-shop-by-movement></section>

<section app-home-fit-details></section>
<section app-home-new-arrivals></section>
<section app-home-newsletter-signup></section>
